// extracted by mini-css-extract-plugin
export var addressFields = "_mg-0";
export var animationContainer = "_mg-1";
export var footer = "_mg-2";
export var lineItems = "_mg-3";
export var modalContent = "_mg-4";
export var orderName = "_mg-5";
export var strong = "_mg-6";
export var warning = "_mg-7";